export var alertStyle = {
  display: 'flex'
};
export var alertTitleStyle = {
  textAlign: 'left'
};
//# sourceMappingURL=styles.js.map